import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useField } from 'react-final-form';
import { Table as BaseTable, Button as BaseButton, ToggleField } from '@ubeya/shared-web/components';
import { FieldTypes } from '@ubeya/shared/hooks/account/useFields';

const Wrapper = styled.div`
  display: flex;
`;

const Container = styled.div``;

const Button = styled(BaseButton)`
  margin: 20px 0;
`;

const ComplianceNeeded = styled.div`
  color: ${({ theme }) => theme.colors.greenPositive};
  font-weight: 500;
`;

const FieldValue = styled.div`
  margin-left: 10px;
  font-weight: bold;
`;

const Table = styled(BaseTable)`
  margin-top: 10px;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
`;

const Action = styled.div`
  flex: 1;
`;

const PositionComplianceTable = ({ t, setComplianceModal, mappedFields }) => {
  const {
    input: { value: baseFieldsIds }
  } = useField('compliance.fieldsIds');
  const {
    input: { value: baseFieldsValues }
  } = useField('compliance.fieldsValues');

  const fieldsIds = Object.entries(baseFieldsIds).filter(([, value]) => !!value);

  const columns = [
    {
      Header: t('complianceFieldName'),
      dataKey: 'name',
      Cell: ({ rowData: { fieldId } }) => {
        const baseFieldValue = baseFieldsValues[`field-${fieldId}`];
        const fieldValue = Array.isArray(baseFieldValue) ? baseFieldValue : [baseFieldValue];

        const field = mappedFields[fieldId];

        const fieldName = field?.isGeneric ? t(field.slug) : field?.name;

        return (
          <Wrapper>
            {fieldName}
            {field?.fieldTypeId === FieldTypes.FIELD_TYPE_OPTIONS && !!baseFieldValue && (
              <FieldValue>
                -{' '}
                {fieldValue
                  .map((valueId) => t(field?.options?.find((option) => option.id === valueId)?.title))
                  .join(', ')}
              </FieldValue>
            )}
          </Wrapper>
        );
      }
    },

    {
      Header: t('expirationDate'),
      dataKey: 'isExpiry',

      formatter: (_, { fieldId }) => {
        if (mappedFields[fieldId]?.fieldTypeId === FieldTypes.FIELD_TYPE_DATE || mappedFields[fieldId]?.hasExpiration) {
          return <ComplianceNeeded>{t('needed')}</ComplianceNeeded>;
        }
        return '';
      }
    }
  ];

  const data = fieldsIds.map(([key]) => ({ fieldId: Number(key.split('-')[1]) }));

  const onButtonClick = useCallback(() => {
    setComplianceModal({});
  }, [setComplianceModal]);

  return (
    <Container>
      <Actions>
        <Action>
          <Button type="button" secondary narrow onClick={onButtonClick}>
            {fieldsIds?.length > 0 ? t('manageComplianceFields') : ` + ${t('addComplianceFields')} `}
          </Button>
        </Action>
        <Action>
          {fieldsIds?.length > 0 && <ToggleField name="compliance.blockBooking" text={t('complianceBlockBooking')} />}
        </Action>
      </Actions>

      {fieldsIds?.length > 0 && (
        <Table headerRowHeight={50} isLoading={false} autoHeight data={data} columns={columns} shadow={false} />
      )}
    </Container>
  );
};

export default PositionComplianceTable;
